import some from "lodash/some";
import qs from "query-string";
import { matchPath } from "react-router-dom";
import { faireDirectPortalPaths } from "./faireDirectPortalPaths";
export var isValidFaireDirectPath = function(path, faireDirectBrandToken) {
    var _qs_parseUrl = qs.parseUrl(path), pathWithoutQueryParams = _qs_parseUrl.url;
    return some(faireDirectPortalPaths(faireDirectBrandToken), function(validFaireDirectPath) {
        return matchPath(pathWithoutQueryParams, {
            path: validFaireDirectPath,
            exact: true
        });
    });
};
